//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getServePage as _getServePage } from "@/api/managementCenter/serveManage";
export default {
  name: "serverSelect",
  components: {},
  props: [],
  data: function data() {
    return {
      loading: false,
      show: false,
      title: "选择服务",
      current: 1,
      size: 10,
      total: 0,
      list: [],
      serveName: ""
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    dialogShow: function dialogShow() {
      this.show = true;
      this.initServePage();
    },
    initServePage: function initServePage() {
      this.current = 1;
      this.getServePage();
    },
    getServePage: function getServePage() {
      var _this = this;

      this.loading = true;
      var params = {
        current: this.current,
        size: this.size,
        serveName: this.serveName
      };

      _getServePage(params).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.list = data.data.records || [];
          _this.total = data.data.total;
        } else {
          _this.$message.error(data.msg);
        }
      }).finally(function () {
        _this.loading = false;
      });
    },
    changePage: function changePage(val) {
      this.current = val;
      this.getServePage();
    },
    selectServer: function selectServer(row) {
      this.$emit("closeServerSelect", row);
      this.show = false;
    }
  },
  watch: {},
  filters: {}
};